module.exports = __webpack_public_path__ + "img/william-claiborne.3a00d10e.png";